// export const BASE_URL = 'https://dsp.anschina.cn/ltms/platform'

// export const BASE_URL = 'http://localhost:8081/ltms-api/platform'

export const BASE_URL = 'https://dddy.sen-chang.cn/platform'
